export const REQUESTS_ACTIONS = {
  REQUESTED: 'requests/requested',
  SUCCEEDED: 'requests/succeeded',
  FAILED: 'requests/failed',
};

export const RELOAD_ACTIONS = {
  REQUESTED: 'reload/requested',
};

export interface RequestsSucceeded {
  type: string;
  payload: { requests: any[] };
}

export const requestsSucceeded = (requests: any[]): RequestsSucceeded => ({
  type: REQUESTS_ACTIONS.SUCCEEDED,
  payload: { requests },
});

export interface RequestsRequested {
  type: string;
}

export const requestsRequested = (): RequestsRequested => ({
  type: REQUESTS_ACTIONS.REQUESTED,
});

export interface RequestsFailed {
  type: string;
  error: string;
}

export const requestsFailed = (error: string) => ({
  error,
  type: REQUESTS_ACTIONS.FAILED,
});

export const reloadRequested = (request: any, collections: any[]) => ({
  type: RELOAD_ACTIONS.REQUESTED,
  payload: { request, collections },
});

export type RequestsAction =
  | RequestsRequested
  | RequestsSucceeded
  | RequestsFailed;



// WEBPACK FOOTER //
// ./src/scenes/Requests/services/actions.ts